// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".closed-notifications[data-v-052ac382]{position:absolute;left:10px}.closed-notifications__btn[data-v-052ac382]{width:222px;height:56px;border-radius:50px;background:var(--color);border:none}", ""]);
// Exports
module.exports = exports;
